import { getScenarioFaviconUrl } from 'owa-favicon';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import type { TabType } from 'owa-tab-store';
import getProjectionFaviconScenario from './getProjectionFaviconScenario';

export default function getProjectionFaviconUrl(tabType: TabType): string | undefined {
    if (!isGlobalFeatureEnabled('mail-updateHostAppIcon')) {
        return undefined;
    }

    const scenario = getProjectionFaviconScenario(tabType);
    return scenario ? getScenarioFaviconUrl(scenario) : undefined;
}
